// Format a Date as "Mmm yy" — e.g. Apr 2026 → "Apr 26". Used by RolloutNew
// to pre-fill the AM-editable monthYearLabel field at creation; the
// format isn't enforced beyond that point — see resolveMonthYear's note.
//
// Pure and locale-stable: brand naming convention uses fixed English month
// abbreviations regardless of the AM's machine locale, so we hand-roll the
// month list rather than calling Intl.DateTimeFormat (which would render
// "avr 26" on French locales). Two-digit year via modulo so 2099 → "99",
// 2100 → "00" — a problem for our great-grandchildren.

const MONTHS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

export function formatMonthYear(date: Date): string {
  const m = MONTHS[date.getMonth()];
  const yy = String(date.getFullYear() % 100).padStart(2, '0');
  return `${m} ${yy}`;
}

// Pre-P2b-3 polish round 5 §2.3: monthYear now resolves from
// rollout.monthYearLabel exclusively. The previous fallback chain
// (row.startDate → rollout.defaultStartDate → today) was removed
// because it produced inconsistent {monthYear} substitution across
// rows in the same rollout. AMs now author one canonical label per
// rollout and every row inherits it.
//
// Defensive: legacy rollouts pre-dating monthYearLabel land here as
// undefined / null; in that case the helper returns null and call
// sites render the placeholder as "—". Empty-string is treated the
// same as null (the create form rejects empty input, but a stale
// document might still carry one).
export function resolveMonthYear(
  rolloutMonthYearLabel: string | null | undefined,
): string | null {
  if (rolloutMonthYearLabel === null || rolloutMonthYearLabel === undefined) {
    return null;
  }
  if (rolloutMonthYearLabel.length === 0) return null;
  return rolloutMonthYearLabel;
}
